import React, { FC, ReactElement, useState } from 'react';
import { Button } from 'src/domains/common/components/button/button';
import { UploadCSVButtonState } from './UploadCSVButton.state';
import { PromoCodesState } from 'src/domains/casino/webview/bonus-engine/campaign/promo-code/PromoCodes.state';
import { useCommon } from 'src/AppState/Common';

interface UploadCSVButtonType {
    promoCodesState: PromoCodesState;
    disabled: boolean;
}

export const UploadCSVButton: FC<UploadCSVButtonType> = ({ promoCodesState, disabled }): ReactElement => {
    const common = useCommon();
    const [state] = useState(() => new UploadCSVButtonState(common, promoCodesState));
    const { setInputRef, handleClick: handleButtonClick, handleFileUpload } = state;
    return (
        <>
            <Button
                className='box-dashed w-1/2'
                icon='upload'
                onClick={handleButtonClick}
                variant='outline'
                size='default'
                disabled={disabled}
            >
                CSV Upload
            </Button>
            <input
                type='file'
                accept='.csv'
                className='hidden'
                ref={setInputRef}
                onChange={handleFileUpload}
                disabled={disabled}
            />
        </>
    );
};
